module.exports = __webpack_public_path__ + "static/media/step-indicator-3.b54c696c.svg";